import { render, staticRenderFns } from "./Demo.vue?vue&type=template&id=6a71fd12&scoped=true&"
import script from "./Demo.vue?vue&type=script&lang=js&"
export * from "./Demo.vue?vue&type=script&lang=js&"
import style0 from "./Demo.vue?vue&type=style&index=0&id=6a71fd12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a71fd12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a71fd12')) {
      api.createRecord('6a71fd12', component.options)
    } else {
      api.reload('6a71fd12', component.options)
    }
    module.hot.accept("./Demo.vue?vue&type=template&id=6a71fd12&scoped=true&", function () {
      api.rerender('6a71fd12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Reports/Demo.vue"
export default component.exports